'use strict';

angular.module('atex.dam').controller('DamIconCodingMultipleController', [ '$scope', '$http', 'DamMarkAsService', 'DamActivityService',
function($scope, $http, DamMarkAsService, DamActivityService) {
  $scope.iconsReady = false;
  $scope.currentData = {
    currentIconCoding: '0'
  };
  
  $scope.saving = false;
  
  $scope.$watch(function() {
    return $scope.values;
  }, function(values) {
    $scope.currentData.currentIconCoding = '0';
  }, true);
  
  $scope.rate = function(rating) {
    $scope.saving = true;
    var locked = false;
    var oldRating = $scope.currentData.currentIconCoding;
    var idlist = [];
    $.each($scope.values, function(i, value) {
      idlist.push(value.id);
    });
    DamActivityService.lock(idlist).then(function(responses){
      locked = true;
      var data = {
        'aspects' : {
          'contentData' : {
            'data' : {
              '_type' : 'com.atex.onecms.app.dam.markas.DamMarkAsBean',
              'id' : JSON.parse(JSON.stringify(idlist)),
              'field' : 'iconcoding',
              'value' : rating
            }
          }
        }
      };
      var url = "/onecms/dam/content/metadata/markas";
      return $http.put(url, data);
    }).then(function(response) {
      $scope.saving = false;
      $.each($scope.values, function(i, value) {
        var update = {};
        update["id"] = value.id;
        update["rating"] = rating;
        $scope.$root.$broadcast("dam:iconCodingUpdate", update);
      });
      DamActivityService.unlock(idlist);
    }).then(null, function() {
      $scope.currentData.currentIconCoding = oldRating;
      $scope.saving = false;
      if (locked) {
        DamActivityService.unlock(idlist);
      }
    });
  };
  
  DamMarkAsService.loadIcons().then(function(icons) {
    $scope.ratingRange = icons.range;
    $scope.ratingIcons = [icons.icon, icons.selected];
    $scope.iconsReady = true;
  });
}]);

angular.module('atex.dam').directive('damIconCodingMultiple', ['$http', 'DamMarkAsService', function($http, DamMarkAsService) {
  return {
    restrict : 'EA',
    
    templateUrl : 'views/dam-icon-coding-multiple.html',
    
    replace : false,
    
    scope : {
      values : "=",
      buttonStyle:"="
    },
        
    controller : 'DamIconCodingMultipleController',
    
    link : function(scope, element, attrs) {
      
      
    }
    
  };
  
}]);
